module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Subscription removed!","description":"Your email was removed with success from our list.","developed":"Developed by","wepipe-forms":"wepipe forms"},"pt-BR":{"title":"Inscrição cancelada!","description":"Seu e-mail foi removido com sucesso da nossa lista.","developed":"Desenvolvido por","wepipe-forms":"wepipe forms"}}')
  delete Component.options._Ctor
}
